import { cx } from "@suse-o11y/class-variance";
import { IconStarEmpty, IconStarFull } from "@suse-o11y/icons";
import React from "react";

import styles from "./_star.module.css";

export interface StarProps extends React.ComponentPropsWithoutRef<"button"> {
	/**
	 * Renders a "skeleton star" when the starred prop is undefined.
	 */
	starred: undefined | boolean;

	onStarredChange?: (starred: boolean) => void;
}

export const Star = React.forwardRef<React.ElementRef<"button">, StarProps>(
	({ starred, onStarredChange, className, ...props }, ref) => (
		<button
			aria-checked={Boolean(starred)}
			aria-label="Star"
			className={cx(styles.star, className)}
			ref={ref}
			role="checkbox"
			{...props}
			onClick={(event) => {
				// the star component is often used inside a button or a link, so we need to stop the event from propagating
				event.stopPropagation();
				event.preventDefault();
				if (starred != null) {
					onStarredChange?.(!starred);
				}

				props.onClick?.(event);
			}}
		>
			{starred == null || onStarredChange == null ? (
				<IconStarFull
					className={cx(styles.icon, starred == null ? "animate-pulse cursor-wait text-grey-400" : styles.iconFull)}
				/>
			) : (
				<>
					<IconStarEmpty className={styles.icon} />
					<IconStarFull className={cx(styles.icon, styles.iconFull)} />
				</>
			)}
		</button>
	),
);
if (import.meta.env.DEV) {
	Star.displayName = "Star";
}
